import difference from 'lodash/difference';
import { isMobile } from 'react-device-detect';
import { browserHistory } from 'react-router';
import { toast } from 'react-toastify';
import request from 'superagent';
import { I18n } from 'react-redux-i18n';

export function defaultToast(autoClose = 6000) {
  return {
    position: 'top-center',
    autoClose: autoClose,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };
}

export function addError(m, dismissable = true) {
  let message;
  if (m && m.message) message = m.message;
  else if (m && m.text) message = m.text;
  else if (typeof m === 'string') message = m;
  else message = I18n.t('main.toast.error');

  return {
    type: 'ADD_TOAST',
    toast: () => toast.error(message, defaultToast()),
    dismissable,
  };
}

export function addSuccess(m, dismissable = true) {
  let message;
  if (m && m.message) message = m.message;
  else if (m && m.text) message = m.text;
  else if (typeof m === 'string') message = m;
  else message = I18n.t('main.toast.done');

  return {
    type: 'ADD_TOAST',
    toast: () => toast.success(message, defaultToast()),
    dismissable,
  };
}

export function addStatus(message, dismissable = true) {
  return {
    type: 'ADD_TOAST',
    toast: () => toast.info(message, defaultToast()),
    dismissable,
  };
}

export function setLauncherGuideVisibility(value) {
  return {
    type: 'LAUNCHER_GUIDE',
    value,
  };
}

export function setIsUserOnline(value) {
  return {
    type: 'IS_USER_ONLINE',
    value,
  };
}

export function routeChange() {
  return {
    type: 'REMOVE_TOASTS',
    toast: id => {
      if (typeof id !== 'undefined') toast.dismiss(id);
    },
  };
}

function receiveAvatars(avatars) {
  return {
    type: 'RECEIVE_AVATARS',
    avatars,
  };
}

export function addQuery(query) {
  const location = Object.assign({}, browserHistory.getCurrentLocation());
  Object.assign(location.query, query);
  browserHistory.push(location);
}

export function removeQuery(...queryNames) {
  const location = Object.assign({}, browserHistory.getCurrentLocation());
  queryNames.forEach(q => delete location.query[q]);
  browserHistory.push(location);
}

export function isSubsValid(user) {
  return (
    user.subs &&
    (new Date(user.subs.valid) > new Date() || user.subs.lessons > 0)
  );
}

export const COURSE_ACCESS_GROUPS = ['admin', 'teacher'];

export function hasCourseAccess(user) {
  return (
    isSubsValid(user) ||
    (user && COURSE_ACCESS_GROUPS.includes(user.group))
  );
}

export function initCarrotQuest(user) {
  if (process.env.REACT_APP_HOSTNAME === 'app.progkids.com') {
    if (typeof carrotquest !== 'undefined') {
      // eslint-disable-next-line no-undef
      carrotquest.auth(user._id.toString(), user.carrotQuestHash);
      // eslint-disable-next-line no-undef
      carrotquest.identify({
        $email: user.email,
        $phone: user.phone ? user.phone : '',
        $name: user.realname ? user.realname : '',
        'Текущий тариф': user.subs.plan ? user.subs.plan : '',
        'Текущий баланс уроков': user.subs.lessons ? user.subs.lessons : '',
      });
    }
  }
}

export function authCarrotQuestEvent() {
  if (typeof carrotquest !== 'undefined') {
    // eslint-disable-next-line no-undef
    carrotquest.track('$authorized');
  }
}

export function trackYandexGoal(goal, params = {}) {
  if (typeof yaCounter48800852 !== 'undefined') {
    // eslint-disable-next-line no-undef
    yaCounter48800852.reachGoal(goal, params);
  }
}

export function trackYandexParams(params) {
  if (typeof yaCounter48800852 !== 'undefined') {
    // eslint-disable-next-line no-undef
    yaCounter48800852.params(params);
  }
}

export function trackProgkids(url, action) {
  request
    .post('/analytic/track')
    .send({ url: url, action: action })
    .end(() => {});
}

export function addMarketingFlags(flags) {
  let cachedFlags = localStorage.getItem('marketingFlags');
  cachedFlags = cachedFlags
    ? Array.isArray(cachedFlags)
      ? cachedFlags
      : [cachedFlags]
    : [];
  localStorage.setItem('marketingFlags', [
    ...cachedFlags,
    ...difference(flags, cachedFlags),
  ]);
}

export function checkMarketingFlagPrefix(user, prefix) {
  if (user && user.marketing && user.marketing.flags) {
    return user.marketing.flags.some(flag => flag.startsWith(prefix));
  } else {
    let cachedFlags = localStorage.getItem('marketingFlags');
    if (cachedFlags && cachedFlags.length > 0) {
      //Because string stored in localstorage
      return cachedFlags.includes(prefix);
    }

    return false;
  }
}

export function checkMarketingFlag(user, flag) {
  if (user && user.marketing && user.marketing.flags) {
    return user.marketing.flags.includes(flag);
  } else {
    let cachedFlags = localStorage.getItem('marketingFlags');
    if (cachedFlags && cachedFlags.length > 0) {
      return cachedFlags.includes(flag);
    }

    return false;
  }
}

export function generateUpdatedMarketing(user) {
  let marketing = (user && user.marketing) || {};

  let cachedUrl = localStorage.getItem('initialUrl');
  if (!marketing.initialUrl && cachedUrl) {
    marketing.initialUrl = cachedUrl;
  }

  let cachedFlags = localStorage.getItem('marketingFlags');
  cachedFlags = cachedFlags ? cachedFlags.split(',') : [];
  marketing.flags = marketing.flags || [];
  const newFlags =
    cachedFlags.length > 0 ? difference(cachedFlags, marketing.flags) : [];
  if (newFlags.length > 0) {
    marketing.flags = [...marketing.flags, ...newFlags];
  }

  const currentDevice = `${isMobile ? 'mobile' : 'computer'}`;
  if (!marketing.firstDevice) {
    marketing.firstDevice = currentDevice;
  }
  marketing.lastDevice = currentDevice;

  return marketing;
}

export function getAvatars() {
  return dispatch => {
    request.get('/user/getAvatars').end((err, res) => {
      if (err) {
        addError(err.toString());
        dispatch(receiveAvatars([]));
      } else {
        dispatch(receiveAvatars(res.body));
      }
    });
  };
}

export function lazyLoadYoutube() {
  var div,
    n,
    v = document.getElementsByClassName('youtube-player');
  for (n = 0; n < v.length; n++) {
    div = document.createElement('div');
    div.setAttribute('data-id', v[n].dataset.id);
    div.innerHTML = labnolThumb(v[n].dataset.id);
    div.onclick = labnolIframe;
    v[n].appendChild(div);
  }
}

function labnolThumb(id) {
  var thumb =
      '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg" alt="youtube cover">',
    play = '<div class="play"></div>';
  return thumb.replace('ID', id) + play;
}

function labnolIframe() {
  var iframe = document.createElement('iframe');
  var embed =
    'https://www.youtube.com/embed/ID?autoplay=1&amp;rel=0&amp;showinfo=0';
  iframe.setAttribute('src', embed.replace('ID', this.dataset.id));
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  this.parentNode.replaceChild(iframe, this);
}
